import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watchEffect } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAllToggle',
  props: {
    totalItemCount: null,
    selectedItemCount: null,
    skipEmptyFilter: { type: Boolean },
    emptyIsAll: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'toggle', isAllSelected: boolean)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  totalItemCount?: number
  selectedItemCount?: number
  skipEmptyFilter?: boolean
  emptyIsAll?: boolean
}





const isAllSelected = ref(true)
const selectedCounter = ref('')

// old watch effect. Will be replaced with new watch effect below,
// once "emptyIsAll" becomes the default mode.
watchEffect(() => {
  if (props.emptyIsAll) return

  isAllSelected.value = props.totalItemCount === props.selectedItemCount

  if (isAllSelected.value) {
    selectedCounter.value = 'All'
  } else if (
    props.selectedItemCount === 0 &&
    props.totalItemCount !== undefined
  ) {
    selectedCounter.value = props.skipEmptyFilter ? 'N/A' : 'None'
  } else if (
    props.selectedItemCount === 0 &&
    props.totalItemCount === undefined
  ) {
    selectedCounter.value = 'All'
  } else if (
    props.selectedItemCount !== undefined &&
    props.totalItemCount !== undefined
  ) {
    selectedCounter.value = `${props.selectedItemCount} / ${props.totalItemCount}`
  } else if (
    props.selectedItemCount !== undefined &&
    props.totalItemCount === undefined
  ) {
    selectedCounter.value = `${props.selectedItemCount}`
  }
})

// new watch effect. keep this one once "emptyIsAll" is the default mode!
watchEffect(() => {
  if (!props.emptyIsAll) return

  isAllSelected.value = props.totalItemCount === props.selectedItemCount

  if (props.selectedItemCount && props.totalItemCount) {
    selectedCounter.value = `${props.selectedItemCount} / ${props.totalItemCount}`
  } else if (props.selectedItemCount) {
    selectedCounter.value = `${props.selectedItemCount}`
  } else {
    selectedCounter.value = 'All'
  }
})

const tooltipText = computed(() => {
  if (props.emptyIsAll) {
    return isAllSelected.value ? 'Click to reset' : 'Click to select all'
  }
  return isAllSelected.value ? 'Click to hide all' : 'Click to show all'
})

const chipColor = computed(() => {
  if (selectedCounter.value === 'All') {
    return 'var(--color-silver)'
  } else if (selectedCounter.value === 'None') {
    return 'var(--color-red--lighter)'
  } else if (selectedCounter.value === 'N/A') {
    return 'var(--color-yellow--lighter)'
  } else {
    return 'var(--color-blue--lighter)'
  }
})

return { __sfc: true,props, emit, isAllSelected, selectedCounter, tooltipText, chipColor }
}

})